import { colors } from '@material-ui/core';

import SonusLogoLogin from 'src/assets/sonus_stacked_logo.svg';
import SonusLogoTopbar from 'src/assets/sonus_logo.svg';
import SonusFavicon from 'src/assets/sonus_favicon.png';
import SonusCoverPageLogo from 'src/assets/sonus_cover_page.png';

const sonusBrandConfig = {
  urls: [
    'sonus.iriss.com',
    'sonus.prosaris.ca',
    'sonus-staging-us.prosaris.ca',
    'iriss-new-staging.prosaris.ca',
    'iriss-new.prosaris.ca',
    'sonus-staging.iriss.com',
  ],
  theme: {
    PRIMARY_COLOR: '#4a90e2',
    PRIMARY_DARK: '#3a78b8',
    SECONDARY_COLOR: '#53565a',
    PRIMARY_TEXT: '#53565A',
    ACCENT_TEXT: '#ffffff',
    DARK_BACKGROUND: '#2c3e50',
    SUCCESS: '#0D7B3B',
    WARNING: '#B29600',
    ERROR: '#BD1717',
    BRANDING_MAIN: '#1D1F22',
    BRANDING_SHADE: '#191A1D',
    MAIN_LAYOUT: {
      BACKGROUND: '#1D1F22',
      PRIMARY_COLOR: '#4a90e2',
      PRIMARY_DARK: '#3a78b8',
      SECONDARY_COLOR: '#4a90e2',
      ACCENT_COLOR: '#3a78b8',
      TEXT_PRIMARY: '#333740',
      TEXT_SECONDARY: '#333740',
      INPUT_BACKGROUND: '#ffffff',
      INPUT_BORDER: '#333740',
      BUTTON_BACKGROUND: '#1D1F22',
      BUTTON_COLOR: '#ffffff',
      BUTTON_HOVER: '#0f1012',
    },
    UNIT_TOGGLE_BUTTON: {
      ACTIVE: {
        BACKGROUND: '#4a90e2',
        COLOR: '#ffffff',
        HOVER: {
          BACKGROUND: '#3a78b8',
          COLOR: '#ffffff',
        },
      },
      INACTIVE: {
        BACKGROUND: '#ffffff',
        COLOR: '#4a90e2',
        HOVER: {
          BACKGROUND: colors.grey[100],
          COLOR: '#4a90e2',
        },
      },
    },
    TOPBAR: {
      ACTIVE: {
        BACKGROUND: '#f3f6f8',
        COLOR: '#4a90e2',
      },
      INACTIVE: {
        BACKGROUND: '#1D1F22',
        COLOR: '#ffffff',
      },
      TEXT: '#ffffff',
    },
  },
  logo: {
    login: {
      src: SonusLogoLogin,
      height: 150,
      alt: 'SONUS Logo',
    },
    topbar: {
      src: SonusLogoTopbar,
      height: 30,
      alt: 'SONUS Logo',
    },
    report: {
      src: SonusLogoTopbar,
      height: 25,
      alt: 'SONUS Logo',
    },
    coverPage: {
      src: SonusCoverPageLogo,
      height: 45,
      alt: 'SONUS Logo',
    },
    favicon: {
      src: SonusFavicon,
    },
  },
  title: 'SONUS Dashboard',
  bannersEnabled: false,
  poweredByEnabled: true,
  ol1Enabled: false,
  overrideExistingRegistration: false,
  viewOnboardingProgress: false,
  companyInfo: {
    name: 'SONUS',
    email: 'support@iriss.com',
  },
};

export default sonusBrandConfig;
